import { createContext } from 'react'

export const JobDetailsContext = createContext<{
    jobRequestId?: number | null
}>({
    jobRequestId: null,
})
